import { isPlatformBrowser } from '@angular/common';
import type { HttpInterceptorFn } from '@angular/common/http';
import { inject, InjectionToken, PLATFORM_ID } from '@angular/core';
import { environment } from '../environments/environment';

/**
 * Absolute origin for REST calls to sbe-sms-api (e.g. `http://localhost:3008`).
 * Empty string keeps relative paths (same origin behind sbe-infra-gateway).
 */
export const SMS_HTTP_API_BASE_URL = new InjectionToken<string>(
  'SMS_HTTP_API_BASE_URL',
);

export function smsHttpApiBaseUrlFactory(platformId: object): string {
  if (!isPlatformBrowser(platformId)) {
    return '';
  }
  return environment.smsApiBaseUrl;
}

export const smsHttpApiBaseUrlProvider = {
  provide: SMS_HTTP_API_BASE_URL,
  useFactory: smsHttpApiBaseUrlFactory,
  deps: [PLATFORM_ID],
};

/**
 * Prepends `SMS_HTTP_API_BASE_URL` to relative requests (starting with `/`). No-op when
 * the token is empty (same-origin staging/production) so production stays on the
 * gateway-managed path.
 */
export const smsApiBaseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const baseUrl = inject(SMS_HTTP_API_BASE_URL);
  if (!baseUrl || !req.url.startsWith('/')) {
    return next(req);
  }
  const normalizedBase = baseUrl.endsWith('/')
    ? baseUrl.slice(0, -1)
    : baseUrl;
  return next(req.clone({ url: `${normalizedBase}${req.url}` }));
};
